import React, { useEffect, useState } from "react";
import E_Alerts_Notification_Header from "./view/_alerts_notification_header";
import E_Alerts_Notification_Body from "./e_alerts_notification_body";
import { Card, CardContent, Grid, makeStyles } from "@material-ui/core";
import getContentData from "./model/e_meter_alert_service";
import { useSelector } from "react-redux";
import { routePaths } from "../config/route-paths";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const useStyle = makeStyles({
  outsideCard: {
    height: "100%"
  },
  paddingCardContent:{
    paddingTop:"0.3rem",
    paddingBottom:"0.3rem !important"
  }
});

export const AutoOpenContext = React.createContext();

export default function E_Alerts_Notification(props) {
  let classes = useStyle();
  const {t:content, ready: contentReady}=useTranslation("content-E_ALERTS_AND_NOTIFICATIONS")
  let [header, setHeader] = useState();
  let [data, setData] = useState(false);
  let [childWidget, setChildWidget] = useState([]);
  let [autoOpenData, setAutoOpenData] = useState();

  let widgets = useSelector((store) => store?.parametersWidgets?.WidgetLookUp);
  const browserName = useSelector((store) => store?.browserDetect?.browserName);

  const noContent=content("E_ALERTS_AND_NOTIFICATIONS_NO_CONTENT_TITLE").answer
  useEffect(() => {
    widgets &&
      widgets.map((item) =>
        item.widgetCode === "E_SIDEBAR.ALERTS" &&
        item.widgetDefaultValue === "true"
          ? setChildWidget(item.children)
          : null
      );
  }, [widgets]);

  useEffect(()=>{
    let enabled_state_value=localStorage.getItem("enabled_state")
    if(enabled_state_value)
    localStorage.removeItem("enabled_state")
  },[])

  let languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );


  useEffect(() => {
    setAutoOpenData(props?.location?.state?.data)
  }, [props?.location]);

  return (
    <AutoOpenContext.Provider value={{autoOpenData, setAutoOpenData}}>
      {childWidget.length > 0 && (
        <Card 
          className={classes.outsideCard} 
          style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
        >
          <CardContent className={classes.paddingCardContent}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <E_Alerts_Notification_Header/>
                </Grid>
                <Grid item xs={12}>
                  <E_Alerts_Notification_Body noContent={noContent} noContentContentReady={contentReady} childWidget={childWidget} />
                </Grid>
              </Grid>
          </CardContent>
        </Card>
      )}
    </AutoOpenContext.Provider>
  );
}
